var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgProductEye(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 18,
    viewBox: "0 0 23 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.2465 7.77314C21.745 8.42522 21.745 9.30553 21.2465 9.95655C19.6762 12.0064 15.9089 16.227 11.5105 16.227C7.11217 16.227 3.34485 12.0064 1.7746 9.95655C1.53205 9.64432 1.40039 9.26022 1.40039 8.86485C1.40039 8.46948 1.53205 8.08537 1.7746 7.77314C3.34485 5.72331 7.11217 1.50269 11.5105 1.50269C15.9089 1.50269 19.6762 5.72331 21.2465 7.77314V7.77314Z",
    stroke: "black",
    strokeOpacity: 0.75,
    strokeWidth: 2.45405,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5097 12.02C13.2523 12.02 14.6649 10.6073 14.6649 8.86475C14.6649 7.12217 13.2523 5.70953 11.5097 5.70953C9.76713 5.70953 8.35449 7.12217 8.35449 8.86475C8.35449 10.6073 9.76713 12.02 11.5097 12.02Z",
    stroke: "black",
    strokeOpacity: 0.75,
    strokeWidth: 2.45405,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProductEye);
export default __webpack_public_path__ + "static/media/product_eye.06e298eaedd9f62a339b08decd9c0aa3.svg";
export { ForwardRef as ReactComponent };